import { useEffect, useRef } from 'react'
import { DisplayController } from '../utils/dom'

export function useDisplayController(ref: React.RefObject<HTMLElement>) {
  const instance = useRef<DisplayController | null>(null)
  useEffect(() => {
    const elem = ref.current

    if (!elem) return

    instance.current = new DisplayController(elem as HTMLDivElement)

    return () => instance.current?.dispose()
  }, [ref])

  return instance.current
}
